import { create } from 'zustand';

type DisclaimerTextInViewState = {
  isDisclaimerTextBelowFold: boolean;
};

type DisclaimerTextInViewActions = {
  setIsDisclaimerTextBelowFold: (isDisclaimerTextBelowFold: boolean) => void;
};

const store = create<DisclaimerTextInViewState & DisclaimerTextInViewActions>((set) => ({
  isDisclaimerTextBelowFold: true,
  setIsDisclaimerTextBelowFold: (isDisclaimerTextBelowFold) => set({ isDisclaimerTextBelowFold }),
}));

export const useDisclaimerTextVisibilityStore = () => {
  const isDisclaimerTextBelowFold = store((state) => state.isDisclaimerTextBelowFold);
  const setIsDisclaimerTextBelowFold = store((state) => state.setIsDisclaimerTextBelowFold);

  return {
    isDisclaimerTextBelowFold,
    setIsDisclaimerTextBelowFold,
  };
};
